import { render } from "./UserSendDocument.vue?vue&type=template&id=7385aeb6"
import script from "./UserSendDocument.vue?vue&type=script&lang=js"
export * from "./UserSendDocument.vue?vue&type=script&lang=js"

import "./UserSendDocument.vue?vue&type=style&index=0&id=7385aeb6&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__